'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUnderline = exports.StyledPlaceholder = exports.StyledLabel = exports.StyledError = exports.StyledTextAreaShadow = exports.StyledTextAreaInput = exports.StyledTextArea = exports.StyledInput = exports.StyledTextField = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  cursor: ', ';\n  display: inline-block;\n  font-size: ', ';\n  height: ', 'px;\n  line-height: ', 'px;\n  position: relative;\n  transition: height 200ms ease-out;\n  width: ', ';\n  ', '\n\n  ', '\n'], ['\n  background-color: ', ';\n  cursor: ', ';\n  display: inline-block;\n  font-size: ', ';\n  height: ', 'px;\n  line-height: ', 'px;\n  position: relative;\n  transition: height 200ms ease-out;\n  width: ', ';\n  ', '\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 0px;\n  position: relative;\n  width: 100%;\n  border: none;\n  outline: none;\n  background-color: rgba(0, 0, 0, 0);\n  color: ', ';\n  -webkit-text-fill-color: currentColor;\n  cursor: inherit;\n  font: inherit;\n  font-family: ', ';\n  line-height: inherit;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  height: 100%;\n  box-sizing: border-box;\n  margin-top: ', ';\n  -webkit-appearance: textfield;\n\n  ', '\n'], ['\n  padding: 0px;\n  position: relative;\n  width: 100%;\n  border: none;\n  outline: none;\n  background-color: rgba(0, 0, 0, 0);\n  color: ', ';\n  -webkit-text-fill-color: currentColor;\n  cursor: inherit;\n  font: inherit;\n  font-family: ', ';\n  line-height: inherit;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  height: 100%;\n  box-sizing: border-box;\n  margin-top: ', ';\n  -webkit-appearance: textfield;\n\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  height: 100%;\n  position: relative;\n  ', '\n'], ['\n  height: 100%;\n  position: relative;\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  ', '\n\n  height: ', 'px;\n  margin-top: ', 'px;\n  margin-bottom: ', 'px;\n  resize: none;\n'], ['\n  ', '\n\n  height: ', 'px;\n  margin-top: ', 'px;\n  margin-bottom: ', 'px;\n  resize: none;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  ', '\n\n  height: auto;\n  margin-top: ', 'px;\n  margin-bottom: ', 'px;\n  position: absolute;\n  resize: none;\n  overflow: hidden;\n  visibility: hidden;\n'], ['\n  ', '\n\n  height: auto;\n  margin-top: ', 'px;\n  margin-bottom: ', 'px;\n  position: absolute;\n  resize: none;\n  overflow: hidden;\n  visibility: hidden;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  position: relative;\n  bottom: 2px;\n  font-size: 12px;\n  line-height: 12px;\n  color: ', ';\n  transition: color .3s ease-out;\n\n  ', '\n\n  ', '\n'], ['\n  position: relative;\n  bottom: 2px;\n  font-size: 12px;\n  line-height: 12px;\n  color: ', ';\n  transition: color .3s ease-out;\n\n  ', '\n\n  ', '\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: ', ';\n  position: absolute;\n  line-height: 22px;\n  top: 38px;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  z-index: 1;\n  transform: ', ';\n  transform-origin: left top 0px;\n  pointer-events: none;\n  user-select: none;\n\n  ', '\n'], ['\n  color: ', ';\n  position: absolute;\n  line-height: 22px;\n  top: 38px;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  z-index: 1;\n  transform: ', ';\n  transform-origin: left top 0px;\n  pointer-events: none;\n  user-select: none;\n\n  ', '\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  position: absolute;\n  opacity: ', ';\n  color: ', ';\n  transition: opacity 450ms ease-out;\n  bottom: 12px;\n\n  ', '\n'], ['\n  position: absolute;\n  opacity: ', ';\n  color: ', ';\n  transition: opacity 450ms ease-out;\n  bottom: 12px;\n\n  ', '\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  border-bottom: 1px solid ', ';\n  bottom: 8px;\n  box-sizing: content-box;\n  margin: 0px;\n  position: absolute;\n  width: 100%;\n\n  ', '\n\n  &::before {\n    background-color: ', ';\n    bottom: -1px;\n    content: \'\';\n    display: block;\n    height: 2px;\n    left: 0;\n    position: absolute;\n    transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1);\n    transform: scaleX(', ');\n    width: 100%;\n  }\n\n  ', '\n'], ['\n  border-bottom: 1px solid ', ';\n  bottom: 8px;\n  box-sizing: content-box;\n  margin: 0px;\n  position: absolute;\n  width: 100%;\n\n  ', '\n\n  &::before {\n    background-color: ', ';\n    bottom: -1px;\n    content: \'\';\n    display: block;\n    height: 2px;\n    left: 0;\n    position: absolute;\n    transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1);\n    transform: scaleX(', ');\n    width: 100%;\n  }\n\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTextField = exports.StyledTextField = _styledComponents2.default.div(_templateObject, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'auto';
}, function (props) {
  return props.fontSize;
}, function (props) {
  return (props.rows - 1) * props.lineHeight + (props.floatingLabelText ? 72 : 48);
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fullWidth ? '100%' : props.width;
}, function (props) {
  return props.style;
}, function (props) {
  return props.height && '\n    height: ' + props.height + ';\n  ';
});

StyledTextField.displayName = 'StyledTextField';
var inputStyles = (0, _styledComponents.css)(_templateObject2, function (props) {
  return props.disabled ? props.disabledColor || props.theme.color.base3 : props.textColor || (0, _tinycolor2.default)(props.theme.color.black).setAlpha(0.87).toString();
}, function (props) {
  return props.bold ? props.theme.font.bold : props.theme.font.default;
}, function (props) {
  return props.floatingLabelText && !props.multiLine ? '14px' : '';
}, function (props) {
  return props.inputStyle;
});

var StyledInput = exports.StyledInput = _styledComponents2.default.input(_templateObject3, inputStyles);

// export const StyledTextArea = StyledTextField.withComponent('textarea');
StyledInput.displayName = 'StyledInput';
var StyledTextArea = exports.StyledTextArea = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.textareaStyle;
});

StyledTextArea.displayName = 'StyledTextArea';
var StyledTextAreaInput = exports.StyledTextAreaInput = _styledComponents2.default.textarea(_templateObject5, inputStyles, function (props) {
  return props.height;
}, function (props) {
  return props.floatingLabelText ? 36 : 12;
}, function (props) {
  return props.floatingLabelText ? -36 : -12;
});

StyledTextAreaInput.displayName = 'StyledTextAreaInput';
var StyledTextAreaShadow = exports.StyledTextAreaShadow = _styledComponents2.default.textarea(_templateObject6, inputStyles, function (props) {
  return props.floatingLabelText ? 36 : 12;
}, function (props) {
  return props.floatingLabelText ? -36 : -12;
});

StyledTextAreaShadow.displayName = 'StyledTextAreaShadow';
var StyledError = exports.StyledError = _styledComponents2.default.div(_templateObject7, function (props) {
  return props.theme.color.negative;
}, function (props) {
  return props.errorStyle;
}, function (props) {
  return props.floatingLabelText && '\n    bottom: ' + (props.multiLine ? '3px' : '15px') + '\n  ';
});

StyledError.displayName = 'StyledError';
var StyledLabel = exports.StyledLabel = _styledComponents2.default.label(_templateObject8, function (props) {
  return (0, _tinycolor2.default)(props.theme.color.black).setAlpha(0.3).toString();
}, function (props) {
  return props.shrink ? 'scale(0.75) translate(0, -28px)' : 'scale(1) translate(0px, 0px)';
}, function (props) {
  return props.focus && '\n    color: ' + (props.error ? props.theme.color.negative : props.theme.color[props.variant]) + ';\n  ';
});

StyledLabel.displayName = 'StyledLabel';
var StyledPlaceholder = exports.StyledPlaceholder = _styledComponents2.default.div(_templateObject9, function (props) {
  return props.show ? 1 : 0;
}, function (props) {
  return props.hintColor || (0, _tinycolor2.default)(props.theme.color.black).setAlpha(0.3).toString();
}, function (props) {
  return props.hintStyle;
});

StyledPlaceholder.displayName = 'StyledPlaceholder';
var StyledUnderline = exports.StyledUnderline = _styledComponents2.default.div(_templateObject10, function (props) {
  return props.borderColor || props.theme.color.border;
}, function (props) {
  return props.underlineStyle;
}, function (props) {
  return props.error ? props.theme.color.negative : props.theme.color[props.variant];
}, function (props) {
  return props.focus || props.error ? 1 : 0;
}, function (props) {
  return props.disabled && '\n    border-bottom-style: dotted;\n    border-bottom-width: 2px;\n    border-bottom-color: ' + (props.disabledColor || props.theme.color.base3) + ';\n  ';
});
StyledUnderline.displayName = 'StyledUnderline';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-text-field/styles.js
// module id = 1289
// module chunks = 4